import React from 'react'

import { FormattedMessage } from '@divvy-web/i18n'
import Banner, { BannerColor, BannerType } from '@divvy-web/skylab.banner'

const TilaErrorBanner = () => {
  return (
    <Banner
      backgroundColor={BannerColor.Info}
      bannerType={BannerType.Informative}
      messageContent={
        <FormattedMessage
          defaultMessage='We are still waiting on more information to compile your offer agreement. Refresh browser or check back in a minute or two.'
          id='sputnik.TilaErrorBanner__gXbSwO'
        />
      }
    />
  )
}

export default TilaErrorBanner
